<template>
  <SyContainer>
    <slot name='header'>
      <collaboration-platform-header
        class='layout-tab-header'
        hideBottom
        :templateApi="bannerTemplate.api"
        :templateKeys="bannerTemplate.keys"
      ></collaboration-platform-header>
    </slot>
    <div class='layout-tab-main'>
      <template v-if="!!Object.keys(this.template).length">
        <sy-menu
          :defaultOpeneds="defaultOpeneds"
          :template="{
            data: this.template,
            keys: this.bannerTemplate.keys
          }"
          @switchTab="tab => switchTab(tab)"
        ></sy-menu>
      </template>
      <el-tabs
        v-model="menuCode"
        type='card'
        class='sy-layout-tab__tabs sy-bottom-fixed-parent'
        @tab-click="tab => tabClickHandler(tab)"
        @tab-remove="tab => tabRemoveHandler(tab)"
      >
        <!-- :tab-remove="tab => closeTab(this.tabs.find(item => item.menuCode === tab.name))" -->
        <template v-for="tab in tabs">
          <!-- // 非 portal 可关闭 -->
          <el-tab-pane
            :name="tab.menuCode"
            :key="tab.menuCode"
            :closable="tab.menuCode !== '/portal'"
          >
            <span slot='label'>
              <i v-if="tab.menuCode === '/portal'" class='iconfont'>&#xe7fc;</i>
              {{tab.name}}
            </span>
          </el-tab-pane>
        </template>
        <div class="sy-container__main" v-scrollbarPrettify ref='layouTabContainerMain'>
          <template v-for="tab in tabs">
            <div
              :style="{'padding-bottom': mainPaddingBottom}"
              :data-page-tab-id="tab.uid" 
              :key="tab.uid" 
              v-show="tab.uid === currentTabUid"
            >
              <component :is="getComponent(tab.uid)" :key="tab.instanceUid"></component>
            </div>
          </template>
        </div>
      </el-tabs>
    </div>
  </SyContainer>
</template>

<script>
import SyContainer from '../container/index'
import CollaborationPlatformHeader from '../collaboration-platform-header/index'
import SyMenu from './menu'
import { mapGetters } from 'vuex'
import { TAB_LIST_SESSION_KEY } from './constans'
import cacheRequest from '../../../utils/cached-request'
import scrollbarPrettify from '../../../directives/scrollbar-prettify'
import LayoutTabMixin from '../page-tab-frame/layout-tab-mixin'
import { isObject } from 'lodash-es'

// 默认
const DEFAULT_TAB_ITEM = {
  name: '工作台',
  url: '/portal',
  query: {},
  // urls: [{ url: '/portal', query: {} }],
  key: '/portal'
}

const genUid = function () {
  return '' + Math.floor(Math.random() * 10000) + (new Date).getTime()
}

// const TAB_LIST_SESSION_KEY = 'LAYOUT_TAB_LIST'

export default {

  directives: {
  	scrollbarPrettify
  },
  components: { SyContainer, CollaborationPlatformHeader, SyMenu },
  mixins: [LayoutTabMixin],
  props: {
    bannerTemplate: {
      type: Object,
      default: () => ({})
    },
    defaultOpeneds: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    menuCode () {
      // 菜单所属code，非列表页定位菜单使用
      let menuCode =  this.$route.query.menuCode || this.$route.params.objectApiName || this.$route.meta.menuCode || this.$route.meta.authCode
      let path = menuCode ?? this.$route.path
      let arr = path.split('')
      // 适配路由末尾带/而无法展开默认
      return arr[arr.length - 1] === '/' ? arr.slice(0, arr.length - 1).join('') : path
    },
    isPortal () {
      return this.menuCode === '/portal'
    },
    mainPaddingBottom () {
      const { fixedBottom } = this
      if (!fixedBottom?.length) return ''
      const { height } = fixedBottom.find(item => item.key === 'bottomFixed')
      return `${height}px`
    },
    ...mapGetters(['allMenu'])
  },
  data () {
    return {
      MENU_TAB_LIST: [DEFAULT_TAB_ITEM],
      template: {},
      fixedBottom: null
    }
  },
  methods: {
    tabClickHandler (tab) {
      const tabItem = this.tabs.find(item => tab.name === item.menuCode)
      if (tab.name === this.menuCode) return false
      this.switchTab(tabItem)
    },
    // 删除页签
    tabRemoveHandler (tab) {
      const tabItem = this.tabs.find(item => tab === item.menuCode)
      this.closeTab(tabItem)
    },
    // 页面配置信息
    async getTemplate () {
      if (!this.bannerTemplate?.api) return
      const timeInterval = 24 * 60 * 60 * 1000 // 缓存时间
      const res = await cacheRequest(this.bannerTemplate.api, null, false, null, null, timeInterval)
      if (res.success || res.code === 'success') {
        this.template = res.content || {}
      }
    },
    // 被 LayoutTabMixin 依赖
    getTabName () {
      const routeMap = this.$route
      const menuKey = Object.keys(this.allMenu).find(item => item.indexOf(this.menuCode) > -1)
      const menuItem = this.allMenu[menuKey]
      routeMap.meta.title = menuItem
        ? menuItem.applicationName || menuItem.name
        : isObject(routeMap.meta.title) ? window.fe.getPageText(routeMap.meta.title) : routeMap.meta.title
        
      return routeMap.meta.title
    },
    // 被 LayoutTabMixin 依赖
    initTabs () {
      let storageTabs = JSON.parse(sessionStorage.getItem(TAB_LIST_SESSION_KEY)) || []
      let portalFlag = !!storageTabs.find(item => item.menuCode === '/portal')
      if (!portalFlag) {
        storageTabs.unshift({
          uid: genUid(), // 此tab 的uid，时间戳+随机数
          menuCode: '/portal', // 同一个 menuCode 值的所有页面共享同一个tab
          path: '/portal', // 当前展示的页面路由
          fullPath: '/portal',
          name: this.getPortalName(),
          instanceUid: genUid()
        })
      }
      return storageTabs
    },
    // portal页签名称
    getPortalName () {
      // 首次进入页面 path ≠ portal 需要
      const portalName = {
        'zh-CN': '工作台',
        en: 'Workbench',
        jp: '工作台_jp'
      }
      const _route = this.$route
      if (this.isPortal) {
        return isObject(_route.meta.title) ? window.fe.getPageText(_route.meta.title) : _route.meta.title
      } else {
        return window.fe.getPageText(portalName)
      }
    }
  },
  watch: {
    '$route': {
      handler () {
        this.fixedBottom = window.fe.fixedBottom || null
        // this.updateMenuTabList()
        // 页面跳转重置滚动条
        this.$refs['layouTabContainerMain'] && (this.$refs['layouTabContainerMain'].scrollTop = 0)
      },
      immediate: true
    }
  },
  mounted () {
    this.getTemplate()
  }
}
</script>

<style scoped lang="scss">
/* 
** tabs样式覆盖
*/
.sy-layout-tab__tabs {
  height: 100%;
  flex: 1;
  min-width: 1200px;
  width: 100%;
  min-width: 1000px;
  ::v-deep {
    &>.el-tabs__header {
      padding: 8px 8px 0;
      background-color: #fff;
      margin: 0;
      // .el-tabs__item:first-child {
      //   border-left: 1px solid #E3E6F0;
      // }
    }
    &>.el-tabs__header .el-tabs__nav {
      background-color: #fff;
      border: none;
    }
    &>.el-tabs__nav-next,
    &>.el-tabs__nav-prev {
      line-height: 38px;
    }
    &>.el-tabs__header .el-tabs__item {
      padding: 8px 16px !important;
      font-size: 14px;
      line-height: 20px;
      height: auto;
      border-bottom: 1px solid #E3E6F0;
      border-left: none;
      border-radius: 8px 8px 0 0;
      .iconfont {
        margin-right: 8px;
      }
      // .el-tabs__item:last-child {
      //   padding: 8px 16px;
      // }
      span {
        font-weight: normal;
      }
      .el-icon-close {
        width: 14px;
        :hover {
          padding-left: 16px;
        }
      }
      &.is-active {
        box-shadow: 0px -2px 3px rgba(227, 230, 240, 0.6);
        border: 1px solid #E3E6F0;
        border-bottom: 1px solid #fff;
        span {
          font-weight: 500;
        }
      }
    }
    &>.el-tabs__content {
      height: calc(100% - 46px);
      // overflow: auto;
    }
    &>.el-tab-pane {
      height: 0;
    }

    .header-content {
      margin-top: 0;
      // background-color: #fff;
      border-radius: 0;
      // top: -8px;
      .header {
        border-radius: 0;
        border: none;
        box-shadow: none;
        width: calc(100% + 34px);
        margin-left: -17px;
      }
    }
    .tab-container {
      margin-top: 8px;
    }
  }
}
.layout-tab-main {
  width: 100%;
  min-width: 1200px;
  height: calc(100% - 33px);
  display: flex;
  flex-direction: row;
  .sy-container__main {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 0 16px 8px;

  }
}

.layout-tab-header {
  ::v-deep .sy-container__header-inner {
    border: none;
  }
}


</style>
